<template>
  <div>
    <div v-if="isHintShown" class="submit-btn wd-bg-orange20 wd-py-2 wd-bottom-16 wd-z-6 md:wd-bg-white md:wd-bottom-0" :class="hintClass">
      {{ hintText }}
    </div>
    <div class="submit-btn wd-bg-white wd-bottom-0 wd-py-3 wd-z-6">
      <v-btn
        class="text-white"
        :class="{ 'wd-pointer-events-none': isSubmitBtnDisabled }"
        height="40"
        :color="submitColor"
        variant="flat"
        block
        @click="$emit('click')"
      >
        {{ submitBtnText }}
      </v-btn>
    </div>
  </div>
</template>

<script lang="ts">
export default defineComponent({
  name: 'FixedBottomSubmitBtn',
  props: {
    submitBtnText: {
      type: String,
      default: '',
    },
    isSubmitBtnDisabled: {
      type: Boolean,
      default: false,
    },
    submitBtnColor: {
      type: String,
      default: '',
    },
    isHintShown: {
      type: Boolean,
      default: false,
    },
    hintText: {
      type: String,
      default: '',
    },
    hintClass: {
      type: String,
      default: 'wd-text-orange50',
    },
  },
  emits: ['click'],
  setup(props) {
    const submitColor = computed(() => props.submitBtnColor || (props.isSubmitBtnDisabled ? 'orange30' : 'orange50'))

    return {
      submitColor,
    }
  },
})
</script>

<style scoped lang="scss">
.submit-btn {
  @apply wd-fixed wd-z-3 wd-left-0 wd-right-0 wd-px-5 sm:wd-px-32 md:wd-relative md:wd-px-20 lg:wd-px-36;
}
</style>
